import { useCallback, useState } from 'react';

const ADVANCED_VISIBILITY_STORAGE_KEY = 'menteo.conversationAdvancedVisibility';

function readAdvancedVisibility(): boolean {
  try {
    return localStorage.getItem(ADVANCED_VISIBILITY_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * Whether diagnostic (advanced-visibility) conversation events are shown. Shared by the inbox and
 * the Playground — one preference, persisted in localStorage so it survives navigation and reloads.
 *
 * Callers must refetch events when this flips: the filtering is server-side
 * (`visibility=all` vs `default`), not a client-side filter.
 */
export function useAdvancedVisibility(): [boolean, (checked: boolean) => void] {
  const [showAdvanced, setShowAdvanced] = useState(readAdvancedVisibility);

  const setPersistedAdvanced = useCallback((checked: boolean) => {
    setShowAdvanced(checked);
    try {
      localStorage.setItem(ADVANCED_VISIBILITY_STORAGE_KEY, String(checked));
    } catch {
      // localStorage unavailable — the toggle still works for this session
    }
  }, []);

  return [showAdvanced, setPersistedAdvanced];
}
